import appStore from 'store';
import api from './api';
import { STATUS_TYPES } from './constants';
import LANGUAGE from 'common/languages';

const store = {
  namespaced: true,
  state: {
    projects: [],
    coinTypeList: [],
    totalCount: 0,
    editingProject: null,
    pagination: {
      page: 1,
      size: 25
    },
    languageList: Object.keys(LANGUAGE).map(item => {
      return {
        value: item.toString(),
        label: LANGUAGE[item]
      };
    })
  },
  getters: {
    projectList: state =>
      state.projects.map(item => ({
        ...item,
        __status: STATUS_TYPES[item.status]
      }))
  },
  mutations: {
    setList(state, payload) {
      state.projects = payload.list;
      state.totalCount = payload.totalCount;
    },
    setPagination(state, payload) {
      state.pagination = payload;
    },
    setCoinTypeList(state, payload) {
      state.coinTypeList = payload;
    },
    setEditingProject(state, payload) {
      state.editingProject = payload;
    }
  },
  actions: {
    getList({ commit }, query) {
      api.getList(query).then(({ data }) => {
        commit('setList', data);
        commit('setPagination', { size: query.size, page: query.page });
      });
    },
    create(context, data) {
      return api.create(data);
    },
    update(context, data) {
      return api.update(data);
    },
    getCoinTypeList({ commit }) {
      api.getCoinTypeList().then(({ data }) => {
        commit('setCoinTypeList', data);
      });
    },
    createRules(context, content) {
      return new Promise(resolve => {
        api.createRulescontent(content).then(res => {
          resolve(res);
        });
      });
    },
    getRules(context, data) {
      return api.getRules(data);
    },
    setBaseAmount(context, content) {
      return new Promise(resolve => {
        api.setBaseConfig(content).then(res => {
          resolve(res);
        });
      });
    },
    getBaseAmount(context, data) {
      return api.getBaseAmount(data);
    },
    freshData(content, data) {
      return api.freshFoundationRes(data);
    },
    setPercent(content, data) {
      return api.setpercent(data);
    },
    getpercent(content, data) {
      return api.getpercent(data);
    },
    searchAmount(content, data) {
      return api.searchAmount(data);
    }
  }
};

appStore.registerModule('foundationProject', store);
